import { createColumnHelper } from '@tanstack/react-table'
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { USER_STATUS } from '../../../config/constants'
import { useEffect, useRef, useState } from 'react'

import '../UserTable.css'
import { usePagination } from '../../../components/Table/usePagination'
import { useSorting } from '../../../components/Table/useSorting'
import { Table } from '../../../components/Table/Table'
import { approveUsers, fetchUsers, searchGroups, searchUsers, useGetUserAPI } from '../UsersApi'

import open_img from '../../../assets/images/open.svg'
import trash_img from '../../../assets/images/trash.svg'

import { toast } from 'react-toastify'
import { setLoading } from '../../../services/global/globalSlice'
import UserModal from './UserModal'
import { fetchGroups } from '../UsersApi'
import GroupModal from './GroupModal'
import IndeterminateCheckbox from '../../../components/Table/Checkbox'


export default function GroupTable(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    
    const columnHelper = createColumnHelper()

    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loadingData, setLoadingData] = useState(true);
    const [searchFilter, setSearchFilter] = useState("")
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [selectedGroup, setSelectedGroup] = useState(null)
    const tableRef = useRef()

    // Make some columns!
    const defaultColumns = [
        {
            id: 'select',
            header: ({ table }) => (
            <IndeterminateCheckbox
                {...{
                checked: table.getIsAllRowsSelected(),
                indeterminate: table.getIsSomeRowsSelected(),
                onChange: table.getToggleAllRowsSelectedHandler(),
                }}
            />
            ),
            cell: ({ row }) => (
            <div className="px-1">
                <IndeterminateCheckbox
                {...{
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }}
                />
            </div>
            ),
        },
    // Display Column
        columnHelper.accessor('group_id', {
            cell: group => group.getValue(),
            header: () => <span>ID</span>
        }),
        columnHelper.accessor('name', {
            cell: group => group.getValue(),
            header: () => <span>{t.groups.name}</span>
        }),
        columnHelper.accessor('users_data', {
            cell: group => group.getValue()?.length,
            header: () => <span>{t.groups.components}</span>
        })
    ]

    const { limit, onPaginationChange, skip, pagination } = usePagination();

    const { sorting, onSortingChange, field, order } = useSorting();

    const [rowSelection, setRowSelection] = useState({})

    const pageCount = Math.round(count / limit) + 1;

    const fetchData = async () => {
        if(searchFilter)
            return await searchGroups({
                pattern: searchFilter,
                skip: skip || 0,
                limit: limit
            });
        else    
            return await fetchGroups({
                skip: skip || 0,
                limit: limit
            });
    }

    useEffect(() => {
        console.log(limit, skip, field, order);
        
        setLoading(true);
        const res = fetchData()
        res.then((_response) => {
            console.log(_response);
            
            if(_response.success && _response?.data?.length > 0){
                setCount(_response?.data?.length % limit === 0 ? skip + limit : count + _response?.data?.length);
                setData(_response?.data);
                setCanLoadMore(_response?.data?.length % limit === 0 ? true : false);
                setLoadingData(false);
            } else {
                tableRef?.current?.setPageIndex(pagination.pageIndex -1)
                setCanLoadMore(false);
            }
        });
    }, [limit, skip, field, order]);

    useEffect(() => {
        setLoading(true);
        const res = fetchData()
        res.then((_response) => {
            if(_response.success){
                setData(_response?.data);
                setCount(_response?.data?.length);
                tableRef?.current?.resetRowSelection(true)
                setLoadingData(false);
            }
        });
    }, []);


    const checkValidateActions = () => {
        return data?.find(u => Object.keys(rowSelection).includes(u.user_id) && (u?.state === "active" || u?.state === "suspended"))
    }

    const onGroupSelect = (e) => {
        setSelectedGroup(e?.id || Object.keys(rowSelection)[0])
    }

    const onUnselectGroup = (e) => {
        setSelectedGroup(null)
    }

    const handleSearchGroups = (e) => {
        e.preventDefault()
        if(searchFilter){
            setLoadingData(true);
            const res = fetchData()
            res.then((_response) => {
                if(_response.success && _response?.data?.length > 0){
                    setData(_response?.data);
                    setCount(_response?.data?.length % limit === 0 ? skip + limit : count + _response?.data?.length);
                    tableRef?.current?.setPageIndex(0)
                    setCanLoadMore(_response?.data?.length % limit === 0 ? true : false);
                    setLoadingData(false);
                } else {
                    tableRef?.current?.setPageIndex(pagination.pageIndex -1)
                    setCanLoadMore(false);
                }
            });
        }
        
    }

    return (
        <div>
            <div className='tableController mb-2 mt-4 d-flex align-items-center justify-content-between'>
                <div className='d-flex justify-content-end pe-2'>
                    <form onSubmit={handleSearchGroups}>
                        <div id='userSearchBar'>
                            <input type='text' value={searchFilter} placeholder={t.users.search_placeholder} onChange={(e)=>setSearchFilter(e.target.value)} />
                        </div>
                    </form>                
                </div>
                <div className='d-flex justify-content-end mt-3 mb-3 pe-2'>
                    <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                        <div className='d-flex table_action' onClick={onGroupSelect} disabled={Object.keys(rowSelection).length !== 1}>
                            <img src={open_img} />
                            {t.actions.open}
                        </div>
                        <div className='d-flex ms-3 pointer table_action' style={{color:"#181818",fontWeight:"500"}} disabled={Object.keys(rowSelection).length <= 0}>
                            <img src={trash_img} />
                            {t.groups.delete_groups}
                        </div>
                    </div>                    
                </div>
            </div>
            <Table
                    ref={tableRef}
                    cols={defaultColumns}
                    data={data}
                    loading={loadingData}
                    onPaginationChange={onPaginationChange}
                    onSortingChange={onSortingChange}
                    pageCount={pageCount}
                    pagination={pagination}
                    sorting={sorting}
                    enableRowSelection={true} 
                    autoResetSelectedRows={true}
                    autoResetPageIndex={true}
                    onRowSelectionChange={setRowSelection}
                    rowSelection={rowSelection}
                    getRowId={(row)=>row.group_id}
                    canLoadMore={canLoadMore}
                    onRowClick={onGroupSelect}
                />
            {selectedGroup ?
                <GroupModal groupId={selectedGroup} onCloseModal={onUnselectGroup} />
            : null}
        </div>
        
    );
}